
import User from '@modules/User';
import {classList} from '@containers/Reorder';
import CatalogItem from '@components/reorder/CatalogItem';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import Icon from '@components/common/Icon';
import {LOGIN_URL} from '@util/URLUtils';

const NotLoggedState = () =>
    <div className={'contain-content flex flex-col text-center py-4 my-4 md:py-12 md:my-12'}>
        <div className="space-content">
            <h1 className={'text-xl font-bold mb-12'}>To see your past purchases, please login</h1>
            <a className={'button primary'}
               href={LOGIN_URL}>
                <Icon.ui name="lock-closed" className="text-xl mr-2"/>
                <span>Sign In</span>
            </a>
            <p className={'mt-6'}>to see items you have previously purchased</p>
        </div>
    </div>
;

const EmptyState = () =>
    <div className={'p-4 md:p-0'}>
        <p>You have not purchased anything yet</p>
    </div>
;

const PurchaseHistory = ( {list, className} ) => {
    if ( !User.isLogged() ) {
        return <NotLoggedState/>
    }
    else {
        return (
            <div className={`contain-content ${className}`}>
                <div className="md:space-content">
                    <h2 className={`hidden md:block ${ classList.page.subheading }`}>Purchase History</h2>
                    <div className={`current ${ classList.card.gridContainer }`}>
                        {!isEmptyOrNil( list )
                            ? list.map( product => <CatalogItem key={product.sku} product={product} /> )
                            : <EmptyState/>
                        }
                    </div>
                </div>
            </div>
        )
    }
};

export default PurchaseHistory
